// import { configureStore } from '@reduxjs/toolkit'

// export default configureStore({
//   reducer: {},
// })




import { configureStore } from '@reduxjs/toolkit'
import sidebarReducer from '../redux/slices/SliderSlice'
// import addressReducer from '../slices/MyprofileSlice'
// import counterReducer from '../slices/CounterSlice';

export const store = configureStore({
  reducer: {
    sidebar: sidebarReducer,
  },
})